export const SUPPORTED_JSON_VERSION = 2;
